import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { ProgramPaths } from '../components/ProgramPaths';
import { WhyNTA } from '../components/WhyNTA';
import { LocationSection } from '../components/LocationSection';
import { AdditionalPrograms } from '../components/AdditionalPrograms';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';
export function Home() {
  return <div className="min-h-screen w-full bg-white" data-id="element-518">
      <Header data-id="element-519" />
      <main data-id="element-520">
        <Hero data-id="element-521" />
        <TrustStrip data-id="element-522" />
        <ProgramPaths data-id="element-523" />
        <WhyNTA data-id="element-524" />
        <LocationSection data-id="element-525" />
        <AdditionalPrograms data-id="element-526" />
        <FAQ data-id="element-527" />
        <FinalCTA data-id="element-528" />
      </main>
      <Footer data-id="element-529" />
      <MobileStickyCTA data-id="element-530" />
      {/* Bottom padding for mobile sticky CTA */}
      <div className="h-[72px] md:hidden" data-id="element-531" />
    </div>;
}